<template>
	<div>about</div>
</template>

<script>
	export default {

	}
</script>

<style>
</style>
